import { render } from "./add-note.vue?vue&type=template&id=0ca062ae&scoped=true"
import script from "./add-note.vue?vue&type=script&lang=js"
export * from "./add-note.vue?vue&type=script&lang=js"

import "./add-note.vue?vue&type=style&index=0&id=0ca062ae&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2424817344/src/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca062ae"],['__file',"src/components/add-note.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ca062ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ca062ae', __exports__)) {
    console.log('reload')
    api.reload('0ca062ae', __exports__)
  }
  
  module.hot.accept("./add-note.vue?vue&type=template&id=0ca062ae&scoped=true", () => {
    console.log('re-render')
    api.rerender('0ca062ae', render)
  })

}


export default __exports__